<script setup lang="ts">
interface Props {
  hasSearchLink?: boolean
  hasOnboardingLink?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  hasSearchLink: false,
  hasOnboardingLink: false,
})

const { getTranslatedLink } = useGetTranslatedLink()
</script>

<template>
  <div>
    <div>
      <p class="text-sm font-semibold uppercase text-gray-500">
        <slot name="user-type" />
      </p>
      <h3 class="text-2xl font-semibold">
        <slot name="title" />
      </h3>
    </div>

    <div class="prose lg:prose-lg mt-4">
      <p>
        <slot name="description" />
      </p>
    </div>

    <div
      v-if="$slots.tip"
      class="bg-peacock-50 mt-4 flex rounded p-4"
    >
      <div class="mr-3 w-6">
        <YscIconsBulb
          class="h-6 w-6"
          highlight="text-yellow-200"
        />
      </div>

      <div class="prose">
        <p>
          <em>
            <slot name="tip" />
          </em>
        </p>
      </div>
    </div>

    <div
      v-if="props.hasSearchLink || props.hasOnboardingLink"
      class="mt-8 text-center"
    >
      <NuxtLink
        v-if="props.hasSearchLink"
        :to="{ name: 's' }"
        class="btn btn-primary"
      >
        {{ getTranslatedLink('s') }}
      </NuxtLink>

      <NuxtLink
        v-if="props.hasOnboardingLink"
        :to="{ name: 'onboarding' }"
        class="btn btn-primary"
      >
        {{ getTranslatedLink('onboarding-step') }}
      </NuxtLink>
    </div>
  </div>
</template>
